import {
    Box,
    Container,
    Grid,
    Skeleton,
    Stack,
    styled,
    SwipeableDrawer,
    TextField,
    Typography,
    IconButton,
    Button,
    CircularProgress,
    Divider,
    CardContent,
    Card,
} from "@mui/material";
import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    limit,
    orderBy,
    query,
    serverTimestamp,
    setDoc,
    where,
} from "firebase/firestore";
import React, { useState } from "react";
import { UserAuth } from "../../context/AuthContext";
import { db } from "../../firebase.config";
import CustomButton from "../../Components/CustomButton";
import EventCard from "../../Components/EventCard";
import Iconify from "../../Components/Iconify";
import { sendPasswordResetEmail } from "firebase/auth";
import { Facebook, Google } from "@mui/icons-material";
import { Variables } from "../../context/VariableContext";
import CustomTextField from "../../Components/CustomTextField";
import Info from "./info";
import Monitoring from "./monitoring";
import { useParams } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import useResponsive from "../../Components/hooks/useResponsive";

const Affiliation = ({ open, count }) => {
    const { user, logIn, signUpSecondStep, signUp, forgotPass, handleFacebookSigin, faceSecondStep } = UserAuth();
    const { openLogin, setOpenLogin } = Variables();
    const { affId } = useParams()
    const [loading, setLoading] = React.useState(false);
    const [event, setEvent] = React.useState();
    const [aff, setAff] = React.useState(0);
    React.useEffect(() => {
        (async () => {
            try {
                if (affId) {
                    const tmp = affId.split('&')
                    console.log(tmp)
                    const affRef = doc(db, `evenement/${tmp[1]?.split('-')[0]}/affiliations/`, `${tmp[0]}`);
                    const affSnap = await getDoc(affRef)
                    if (affSnap.exists() && affSnap?.data().partnerId === user.uid) {
                        setAff(affSnap)
                        console.log(affSnap.data())
                        const docRefCampaign = doc(db, 'evenement', `${affSnap?.data().eventID}`);
                        const docSnapCampaign = await getDoc(docRefCampaign);
                        if (docSnapCampaign.exists()) {
                            setEvent({ id: docSnapCampaign.id, image: docSnapCampaign.data().idVisuel, name: docSnapCampaign.data().nomEvent, debut: docSnapCampaign.data().dateDebut, fin: docSnapCampaign.data().dateFin, venue: docSnapCampaign.data().lieu_event });
                        }
                    }
                }

                /* const q = query(collection(db, `partners/${user.uid}/affiliations`));
                const snapshot = await getDocs(q);
                snapshot.forEach(async (d) => {
                    const docRefCampaign = doc(db, 'evenement', `${d.id.split('-')[0]}`);
                    const docSnapCampaign = await getDoc(docRefCampaign);
                    if (docSnapCampaign.exists()) {
                        // setEvents((events) => [...events, {affId: d.data().affId, id: d.id, data: docSnapCampaign.data() }]);
                    }

                }); */
            } catch (error) {
                console.log(error);
            }
            setLoading(false);
        })();
    }, [user, affId]);

    // champs


    // drawer
    // drawer connection
    const [openConnexion, setOpenConnexion] = React.useState(open);
    const [menu, setMenu] = React.useState(0);
    const smUp = useResponsive("up", "sm");

    const mdUp = useResponsive("up", "md");

    return (
        <Container sx={{ color: 'white' }}>
            <Box sx={{ paddingBottom: 2 }}>
                <CustomButton startIcon={<Iconify icon="material-symbols:arrow-back-ios" />} buttonText={'Retour'} type={'secondaire'} onClick={() => window.history.back()} />
            </Box>

            <Grid container spacing={3} justifyContent='space-between' paddingTop={3}>
                <Grid item xs={12} md={3}>
                    {
                        !mdUp ?
                            <Card sx={{ bgcolor: '#292929', color: 'white', cursor: 'pointer' }}>
                                <Stack direction='row' spacing={1} display="flex" alignItems="center">
                                    <LazyLoadImage
                                        src={`${event?.image}`}
                                        alt={`${event?.image}`}
                                        className="img-lazy"
                                        width={100}
                                        height={100}
                                        style={{ objectFit: 'cover' }}
                                        effect="blur" // opacity | black-and-white
                                    />
                                    <Box>
                                        <Typography variant="h6">{event?.name}</Typography>
                                        <Typography variant="body1" >
                                            {event?.data?.participant} participants
                                        </Typography>
                                    </Box>
                                </Stack>
                            </Card>
                            :
                            <Stack>
                                <Card sx={{ backgroundColor: '#f2f2f2', color: 'black', height: '100%', borderRadius: '7px' }}>
                                    {/* <CardMedia component="img" height="200" image={`${event.data().idVisuel}`} alt="green iguana" /> */}
                                    {/* <CardMedia component="img" height="200" image='./noimage.png' alt="green iguana" /> */}
                                    <LazyLoadImage
                                        src={`${event?.image}`}
                                        alt={`chpotonticket-${event?.name}-${event?.image}`}
                                        className="img-lazy"
                                        width='100%'
                                        height={200}
                                        style={{ objectFit: 'cover' }}
                                        effect="blur" // opacity | black-and-white
                                    />

                                    <CardContent sx={{ padding: 1 }}>
                                        <Typography gutterBottom variant="subtitle1" component="div">
                                            {event?.name}
                                        </Typography>
                                        <Stack direction="row" spacing={1} alignItems="center">
                                            <Stack direction="row" spacing={1} alignItems="center">
                                                <Iconify icon="mdi-light:calendar" sx={{ width: 20, height: 20 }} />
                                                <Typography noWrap variant="caption" color="black">
                                                </Typography>
                                            </Stack>
                                            <Stack spacing={0.5} direction="row">

                                            </Stack>
                                        </Stack>
                                        <Stack direction="row" spacing={1} alignItems="center">
                                            <Iconify icon="icon-park-outline:local-two" sx={{ width: 20, height: 20 }} />
                                            <Typography noWrap variant="body2" color="black">
                                                {event?.venue}
                                            </Typography>
                                        </Stack>
                                    </CardContent>
                                </Card>
                            </Stack>
                    }


                </Grid>
                <Grid item xs={12} md={8}>
                    <Stack>
                        <Stack mb={4} direction='row' spacing={1}>
                            <Box onClick={() => setMenu(0)} sx={menu === 0 ? { bgcolor: '#5E17EB', borderRadius: '30px', cursor: 'pointer' }
                                :
                                { bgcolor: '#292929', borderRadius: '30px', cursor: 'pointer' }} paddingX={2} paddingY={1.25} >
                                <Typography variant='body2'>Informations</Typography>
                            </Box>
                            <Box onClick={() => setMenu(1)} sx={menu === 1 ? { bgcolor: '#5E17EB', borderRadius: '30px', cursor: 'pointer' }
                                :
                                { bgcolor: '#292929', borderRadius: '30px', cursor: 'pointer' }} paddingX={2} paddingY={1.25} >
                                <Typography variant='body2'>Vente</Typography>
                            </Box>
                        </Stack>
                        {
                            menu === 0 ?
                                <Info affiliation={aff} />
                                :
                                <Monitoring affiliation={aff} />
                        }


                    </Stack>

                </Grid>
            </Grid>
        </Container>
    );
};

export default Affiliation;
